import { UserInstrument } from '../models/user';

export enum UserActionType {
    updateUserInstruments = 'updateUserInstruments',
}

export interface UpdateUserInstrumentsAction {
    type: UserActionType.updateUserInstruments;
    payload: Array<UserInstrument>;
}
export const getUpdateUserInstrumentsAction = (
    userInstruments: Array<UserInstrument>,
): UpdateUserInstrumentsAction => ({
    type: UserActionType.updateUserInstruments,
    payload: userInstruments,
});

export type UserAction = UpdateUserInstrumentsAction;
